/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Close/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'



/** @type {import('Simple/types.js').View} */
export default function Close({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/ExpandAction/Content/Close"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaIconArrowDown
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 fill={dtColorsNeutral400}
 height={14}
 width={14}
/>
{children}
</React.Fragment>)
}